const hasOwn = (object, key) => Object.prototype.hasOwnProperty.call(object || {}, key);
const text = (value) => value == null ? "" : String(value);

export function resolveDocumentText(company, doc, type) {
  const settings = company?.document_texts;
  if (hasOwn(settings, type)) {
    const configured = settings[type] || {};
    return { notes: text(configured.notes), terms: text(configured.terms) };
  }
  return {
    notes: text(doc?.notes || company?.default_notes),
    terms: text(doc?.terms || company?.default_terms),
  };
}

export function resolveDocumentBank(company, doc) {
  if (doc?.bank_details && typeof doc.bank_details === "object") return doc.bank_details;
  if (hasOwn(doc, "bank_id")) {
    if (doc.bank_id == null || doc.bank_id === "") return null;
    return (company?.banks || []).find((item) => String(item.id) === String(doc.bank_id)) || null;
  }
  const legacy = {
    bank_name: company?.bank_name || "",
    bank_account: company?.bank_account || "",
    bank_ifsc: company?.bank_ifsc || "",
    upi_id: company?.upi_id || "",
  };
  return Object.values(legacy).some(Boolean) ? legacy : null;
}